"use strict";

exports.__esModule = true;
exports.PhoneInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../../Elements/Icon/Icon");
var _FieldControl = require("../../Elements/FieldControl/FieldControl");
var _CountrySelect = require("../../Compositions/Typeahead/CountrySelect");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for user interaction
 */

const PhoneInput = ({
  requiredLength,
  name,
  id,
  label,
  value,
  promptText,
  promptTextForCode,
  hintForCode,
  hint,
  noOptionsMessage,
  optionalText,
  country,
  callingCode,
  lockCountry,
  lng,
  error,
  errorMsg,
  setFocus,
  disabled,
  stateManaged,
  onBlur,
  onChange,
  onFieldFocus,
  onSelectFocus,
  countryList,
  countryFlagCdnUrl,
  ...props
}) => {
  // ref the input field
  const phoneInput = (0, _react.useRef)();
  // set focus to the field programatically if the prop is true
  (0, _react.useEffect)(() => {
    if (setFocus) phoneInput.current.focus();
  }, []);
  const [countryObject, setCountryObject] = (0, _react.useState)({
    country,
    callingCode
  });
  const cssComponentClass = 'ccl__form-input';
  const cssTextClass = 'ccl__text';
  const handleCountryChange = (_name, newCountry, v) => {
    setCountryObject({
      country: newCountry || v.countryCode,
      callingCode: v.callingCode
    });
    onChange(_name, {
      country: v.countryCode,
      callingCode: v.callingCode,
      number: phoneInput.current.value
    });
  };
  const handleInputChange = evt => {
    onChange(evt, {
      ...countryObject,
      number: evt.target.value
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: [cssComponentClass, `${cssComponentClass}--is-number`, `${cssComponentClass}--is-form-input`, `${cssComponentClass}--is-phone-input`, error ? `${cssComponentClass}--has-error` : '', disabled ? `${cssComponentClass}--is-disabled` : ''].join(' '),
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
      className: `${cssComponentClass}__label ${cssTextClass} ${cssTextClass}--body-text-bold`,
      htmlFor: id || name,
      children: [label, optionalText && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: `${cssComponentClass}__label__optional ${cssTextClass} ${cssTextClass}--small-body-text-italic`,
        children: `(${optionalText})`
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `${cssComponentClass}__field`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `${cssComponentClass}__field__code`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CountrySelect.CountrySelect, {
          name: "Country",
          id: `Country-${id}`,
          hint: hintForCode,
          promptText: promptTextForCode,
          disabled: disabled,
          lockCountry: lockCountry,
          lng: lng,
          noOptionsMessage: noOptionsMessage,
          isSearchable: true,
          defaultValue: countryObject.country,
          onChange: handleCountryChange,
          onBlur: onBlur,
          onFocus: onSelectFocus,
          codeSelect: true,
          usedByPhoneInput: true,
          showFlag: true,
          showName: true,
          showISO: true,
          showISDN: true,
          showResultsFlag: true,
          showResultsName: false,
          showResultsISO: true,
          showResultsISDN: false,
          maxResults: 6,
          size: "large",
          customData: countryList,
          countryFlagCdnUrl: countryFlagCdnUrl
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `${cssComponentClass}__field__input`,
        children: [hint && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: `${cssComponentClass}__hint ${cssTextClass} ${cssTextClass}--informative-text`,
          children: hint
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FieldControl.FieldControl, {
          forwardedRef: phoneInput,
          name: name,
          id: id || name,
          promptText: promptText,
          value: value,
          stateManaged: stateManaged,
          disabled: disabled,
          error: error,
          inputMode: "tel",
          maxLength: requiredLength,
          isNumber: true,
          isStrict: true,
          onChange: handleInputChange,
          onFocus: onFieldFocus,
          onKeyUp: handleInputChange,
          onBlur: onBlur
        })]
      })]
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: `${cssComponentClass}__error-message ${cssTextClass} ${cssTextClass}--error-small-text`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: "error",
        type: "error",
        size: "xs"
      }), errorMsg]
    })]
  });
};
exports.PhoneInput = PhoneInput;
PhoneInput.defaultProps = {
  requiredLength: 0,
  id: '',
  promptText: '',
  promptTextForCode: 'Select',
  value: '',
  hint: 'Area code and phone',
  hintForCode: 'Country code',
  noOptionsMessage: 'No matching options',
  optionalText: '',
  country: '',
  lockCountry: false,
  lng: 'en',
  error: false,
  errorMsg: '',
  disabled: false,
  setFocus: false,
  stateManaged: true,
  countryFlagCdnUrl: '',
  countryList: null,
  onChange: () => {},
  onBlur: () => {}
};